import { useGSAP } from '@gsap/react'
import React, { useRef } from 'react'
import { animateWithGsap } from '../utils/animations';
import { explore1Img, explore2Img} from '../utils';
import gsap from 'gsap';

const Features = () => {
  const videoRef = useRef();

  useGSAP(() => {
    gsap.to('#exploreVideo', {
      scrollTrigger: {
        trigger: '#exploreVideo',
        toggleActions: 'play pause reverse restart',
        start: '-10% bottom',
      },
      onComplete: () => {
        videoRef.current.play();
      }
    })

    animateWithGsap('#features_title', { y:0, opacity:1})
    animateWithGsap(
      '.g_grow',
      { scale: 1, opacity: 2, ease: 'power1' },
      { scrub: 5.5 }
    );
    animateWithGsap(
      '.g_text',
      {y:0, opacity: 1,ease: 'power2.inOut',duration: 1}
    )
  }, []);

  return (
    <section className="h-full common-padding bg-white relative overflow-hidden">
      <div className="screen-max-wdith">
        <div className="mb-12 w-full">
          <h1 id="features_title" className="section-heading text-center">Revolutionizing Real Estate Investing</h1>
        </div>
        
        <div className="flex flex-col justify-center items-center overflow-hidden">
          {/* <div className="mt-32 mb-24 pl-24">
            <h2 className="text-5xl text-slate-900 lg:text-7xl font-semibold">Lorem</h2>
            <h2 className="text-5xl lg:text-7xl font-semibold text-teal-400">Forged in titanium.</h2>
          </div> */}

          <div className="flex-center flex-col sm:px-10">
            {/* <div className="relative h-[50vh] w-full flex items-center">
              <video playsInline id="exploreVideo" className="w-full h-full object-cover object-center" preload="none" muted autoPlay ref={videoRef}>
                <source src={exploreVideo} type="video/mp4" />
              </video>
            </div> */}

            <div className="flex flex-col w-full relative">
              <div className="feature-video-container">
                <div className="overflow-hidden flex-1 h-[50vh]">
                  <img src={explore1Img} alt="titanium" className="feature-video g_grow" />
                </div>
                <div className="overflow-hidden flex-1 h-[50vh]">
                  <img src={explore2Img} alt="titanium 2" className="feature-video g_grow" />
                </div>
              </div>

              <div className="feature-text-container">
                <div className="flex-1 flex-center">
                  <p className="feature-text g_text">
                  At <span className="text-slate-900">
           Investor<span className='text-teal-500'>Rise</span>
           </span>, we are more than just a real estate company—we are a family of brands dedicated to guiding both buyers and sellers through every step of their property journey. Our mission is to provide access to the best off-market property deals, delivering unmatched value directly to our network of investors. By focusing on opportunities beyond the traditional market, we ensure our clients gain a competitive edge in their investment strategy. {' '}
                    {/* <span className="text-slate-900">
           
                    </span>, */}
                   
                  </p>
                </div>

                <div className="flex-1 flex-center">
                  <p className="feature-text g_text">
                  We believe real estate investing shouldn't be complicated. That's why we've reimagined the entire process—making it simpler, smarter, and more accessible than ever. Whether you're looking to expand your investment portfolio or find the perfect buyer for your property, <span className="text-slate-900">
           Investor<span className='text-teal-500'>Rise</span>
           </span> streamlines the experience with expert support and innovative solutions that drive results.
                  </p>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Features